import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom'
import { Routes, Route } from "react-router-dom";
import Model from "./pages/Model"
import Description from "./pages/Description";
import Attributions from './pages/attributions';
import Education from './pages/education';
import Design from './pages/design';
import HomePage from './homepage';
import Contribution from './pages/Contribution';
import Engineering from './pages/engineering';
import Safety from './pages/safety';
import Concept from './pages/proof-of-concept';
import Collaborations from './pages/collaboration';
import Implementation from './pages/implementation';
import Notebook from './pages/notebook';
import HP from './pages/HP';
import Parts from './pages/parts';
import Team from './pages/TEAM';
import Enterpreneurship from './pages/Enterpreneurship';
import Material from './pages/material';
import Communication from './pages/communication';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter basename={process.env.PUBLIC_URL}>
    <Routes>
      <Route path='/' element={<HomePage/>}>
        <Route path="/" element={<App />} />
        <Route path="/description" element={<Description />} />
        <Route path="/attributions" element={<Attributions />} />
        <Route path="/contribution" element={<Contribution />} />
        <Route path="/engineering" element={<Engineering />} />
        <Route path="/safety" element={<Safety/>} />
        <Route path="/proof-of-concept" element={<Concept />} />
        <Route path="/design" element={<Design />} />
        <Route path="/education" element={<Education />} />
        <Route path="/model" element={<Model />} />
        <Route path="/collaborations" element={<Collaborations/>} />
        <Route path="/implementation" element={<Implementation/>} />
        <Route path="/notebook" element={<Notebook />} />
        <Route path="/human-practices" element={<HP/>} />
        <Route path="/parts" element={<Parts/>} />
        <Route path="/team" element={<Team />} />
        <Route path="/entrepreneurship" element={<Enterpreneurship />} />
        <Route path="/methods" element={<Material />} />
        <Route path="/communication" element={<Communication />} />
      </Route>
    </Routes>
  </BrowserRouter>
);

//<Route path="/partnership" element={<Partnership/>} />

